// Função para retornar cor baseada na nota
export function ratingColor(rating) {
    const r = parseFloat(rating);

    // Mapeia notas exatas para cores específicas
    const colorMap = {
        1: '#D32F2F', // Vermelho Escuro Forte
        2: '#F57C00', // Laranja Escuro Vibrante
        3: '#FFA000', // Laranja Amarelado Vibrante
        4: '#FFC107', // Amarelo Ouro Vibrante
        5: '#FFEB3B', // Amarelo Puro Vibrante
        6: '#CDDC39', // Verde Limão
        7: '#8BC34A', // Verde Folha Claro
        8: '#4CAF50', // Verde Padrão Vibrante
        9: '#00E676', // Verde Esmeralda Elétrico
        10: '#69F0AE'  // Verde Água Brilhante
    };

    // Para notas exatas (1, 2, 3, etc.)
    if (Number.isInteger(r) && colorMap[r]) {
        return colorMap[r];
    }

    // Para notas decimais, encontra a cor baseada na faixa
    if (r >= 1 && r < 2) {
        return colorMap[1];
    } else if (r >= 2 && r < 3) {
        return colorMap[2];
    } else if (r >= 3 && r < 4) {
        return colorMap[3];
    } else if (r >= 4 && r < 5) {
        return colorMap[4];
    } else if (r >= 5 && r < 6) {
        return colorMap[5];
    } else if (r >= 6 && r < 7) {
        return colorMap[6];
    } else if (r >= 7 && r < 8) {
        return colorMap[7];
    } else if (r >= 8 && r < 9) {
        return colorMap[8];
    } else if (r >= 9 && r < 10) {
        return colorMap[9];
    } else if (r >= 10) {
        return colorMap[10];
    }

    // Cor padrão para valores inválidos
    return '#000000';
}

// Função para retornar cor de fundo com opacidade baseada na nota
export function ratingBackgroundColor(rating) {
    const r = parseFloat(rating);

    // Mapeia notas exatas para cores específicas com opacidade 0.5
    const backgroundColorMap = {
        1: 'rgba(211, 47, 47, 0.3)',   // Vermelho Escuro Forte
        2: 'rgba(245, 124, 0, 0.3)',   // Laranja Escuro Vibrante
        3: 'rgba(255, 160, 0, 0.3)',   // Laranja Amarelado Vibrante
        4: 'rgba(255, 193, 7, 0.3)',   // Amarelo Ouro Vibrante
        5: 'rgba(255, 235, 59, 0.3)',  // Amarelo Puro Vibrante
        6: 'rgba(205, 220, 57, 0.3)',  // Verde Limão
        7: 'rgba(139, 195, 74, 0.3)',  // Verde Folha Claro
        8: 'rgba(76, 175, 80, 0.3)',   // Verde Padrão Vibrante
        9: 'rgba(0, 230, 118, 0.3)',   // Verde Esmeralda Elétrico
        10: 'rgba(105, 240, 174, 0.3)' // Verde Água Brilhante
    };

    // Para notas exatas (1, 2, 3, etc.)
    if (Number.isInteger(r) && backgroundColorMap[r]) {
        return backgroundColorMap[r];
    }

    // Para notas decimais, encontra a cor baseada na faixa
    if (r >= 1 && r < 2) {
        return backgroundColorMap[1];
    } else if (r >= 2 && r < 3) {
        return backgroundColorMap[2];
    } else if (r >= 3 && r < 4) {
        return backgroundColorMap[3];
    } else if (r >= 4 && r < 5) {
        return backgroundColorMap[4];
    } else if (r >= 5 && r < 6) {
        return backgroundColorMap[5];
    } else if (r >= 6 && r < 7) {
        return backgroundColorMap[6];
    } else if (r >= 7 && r < 8) {
        return backgroundColorMap[7];
    } else if (r >= 8 && r < 9) {
        return backgroundColorMap[8];
    } else if (r >= 9 && r < 10) {
        return backgroundColorMap[9];
    } else if (r >= 10) {
        return backgroundColorMap[10];
    }

    // Cor padrão para valores inválidos
    return 'rgba(0, 0, 0, 0.5)';
}

// Objeto com as cores para fácil acesso
export const RATING_COLORS = {
    1: '#D32F2F', // Vermelho Escuro Forte
    2: '#F57C00', // Laranja Escuro Vibrante
    3: '#FFA000', // Laranja Amarelado Vibrante
    4: '#FFC107', // Amarelo Ouro Vibrante
    5: '#FFEB3B', // Amarelo Puro Vibrante
    6: '#CDDC39', // Verde Limão
    7: '#8BC34A', // Verde Folha Claro
    8: '#4CAF50', // Verde Padrão Vibrante
    9: '#00E676', // Verde Esmeralda Elétrico
    10: '#69F0AE'  // Verde Água Brilhante
};

// Função alternativa usando o objeto de cores
export function getRatingColor(rating) {
    const r = Math.floor(parseFloat(rating));
    return RATING_COLORS[r] || '#000000';
}